"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CARD_TYPES = void 0;
var CARD_TYPES = Object.freeze({
  primary: 'primary',
  secondary: 'secondary'
});
exports.CARD_TYPES = CARD_TYPES;